import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { RetentionClassSchema } from "./conversion-tracking.js";
export const ConsentRegistryEntryV1Schema = z
    .object({
    schemaVersion: z.literal("consent-registry-entry.v1.0"),
    entryId: z.string(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    visitorIdHash: z.string(),
    consentGranted: z.boolean(),
    recordedAt: z.string().datetime(),
    expiresAt: z.string().datetime(),
})
    .strict();
export const CareRetentionPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("care-retention-policy.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    retentionClass: RetentionClassSchema,
    purgeAfterDays: z.number().int().positive(),
    updatedAt: z.string().datetime(),
})
    .strict();
export function careRetentionExpired(recordedAtIso, purgeAfterDays, now = new Date()) {
    const recordedAt = new Date(recordedAtIso);
    const ageMs = now.getTime() - recordedAt.getTime();
    return ageMs > purgeAfterDays * 24 * 60 * 60 * 1000;
}
export function careIdentifierLifecycleStage(consentGranted, retentionExpired) {
    if (retentionExpired)
        return "PURGED";
    if (!consentGranted)
        return "WITHDRAWN";
    return "ACTIVE";
}
//# sourceMappingURL=care-consent-retention.js.map